import { useChat } from '../../contexts/ChatContext';
import ChatPanel from './ChatPanel';

export default function ChatWidget() {
  const { isOpen, toggleChat, messages } = useChat();

  return (
    <>
      {/* Floating Action Button */}
      <button
        onClick={toggleChat}
        className={`fixed bottom-6 right-6 w-14 h-14 rounded-full shadow-lg z-40 flex items-center justify-center transition-all duration-300 hover:scale-110 ${
          isOpen
            ? 'bg-[var(--color-bg-elevated)] border border-[var(--color-border)]'
            : 'bg-gradient-to-br from-lime-400 to-cyan-400 hover:shadow-lime-500/30'
        }`}
        title={isOpen ? 'Close chat' : 'Open chat assistant'}
      >
        {isOpen ? (
          <svg
            className="w-6 h-6 text-[var(--color-text-primary)]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        ) : (
          <svg
            className="w-6 h-6 text-[var(--color-space)]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
            />
          </svg>
        )}

        {/* Unread indicator */}
        {!isOpen && messages.length > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-cyan-400 text-[var(--color-space)] text-xs font-bold rounded-full flex items-center justify-center">
            {messages.filter(m => m.role === 'assistant').length}
          </span>
        )}
      </button>

      {/* Chat Panel */}
      <ChatPanel />
    </>
  );
}
